import { Component } from "@angular/core";
import { takeUntil } from "rxjs/operators";
import { UnsubscribeComponent } from "../../generals/Components";
import { ProductImageInfo } from "../../interfaces/interfaces";
import { ApiService } from "../../services/api.service";

@Component({
    selector: 'app-productimages',
    templateUrl: './productimages.component.html',
    styleUrls: ['./productimages.component.scss']
})
export class ProductImagesComponent extends UnsubscribeComponent {

    productImageInfo: ProductImageInfo[] = [];
    loading: boolean = false;

    constructor(
        private apiService: ApiService
    ) {
        super();
        this.loadProductImageInfo();
    }

    loadProductImageInfo(): void {
        this.loading = true;
        this.apiService.getProductImageInfo().pipe(takeUntil(this.unsubscribe)).subscribe(({productImageInfo}) => {
            this.productImageInfo = productImageInfo.map((productImageInfoItem: ProductImageInfo) => ({
                ...productImageInfoItem,
                loading: false
            }));
        }).add(() => {
            this.loading = false;
        });
    }

    downloadFile(productImageInfo: ProductImageInfo): void {
        this.loading = true;
        productImageInfo.loading = true;
        this.apiService.downloadProductImageInfo(productImageInfo.slug).pipe(takeUntil(this.unsubscribe)).subscribe(({content, filename}) => {
            const a: HTMLAnchorElement = document.createElement('a');
            a.href = window.URL.createObjectURL(new Blob(['\uFEFF', content], {
                type: 'text/csv;charset=UTF-8',
            }));
            a.target = '_blank';
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }).add(() => {
            this.loading = false;
            productImageInfo.loading = false;
        });
    }
}